import { AreaInfo } from '../contract/map'
import area from './area.json'

export const AREA_LIST: AreaInfo[] = area

// 不带全部选项
export const AREA_LIST_NO_ALL = JSON.parse(JSON.stringify(area)).map((province: AreaInfo) => {
  if (province.cities && province.cities[0] && province.cities[0].name == '全部') {
    province.cities.splice(0, 1)
  }
  return province
})

// 县县通地址选择  不带区县选项, 不带港澳台
export const AREA_LIST_OF_COUNTY_LAYOUT = JSON.parse(JSON.stringify(area))
  .slice(1)
  .map((province: AreaInfo) => {
    if (province.cities && province.cities.length) {
      province.cities.map((city: AreaInfo) => {
        city.districts = []
        return city
      })
    }
    return province
  })

/**
 * 不设区县的市
 * 中山市，东莞市，儋州市, 嘉峪关市,
 */
export const NO_DISTRICT_CITY = ['442000', '441900', '460400', '620200']
